/**
 * System actions
 *
 * @author Mamontov Andrey, 18/2023
 */


import { Action } from '@ngrx/store';

export const SET_CONNECTED_STATUS = '[SYSTEM] SET_CONNECTED_STATUS';
export const SET_DISCONNECTED_COUNTER = '[SYSTEM] SET_DISCONNECTED_COUNTER';

export class SetConnectedStatus implements Action {
  readonly type = SET_CONNECTED_STATUS;
  constructor(public payload: boolean) { }
}

export class SetDisConnectedCounter implements Action {
  readonly type = SET_DISCONNECTED_COUNTER;
  constructor(public payload: number) { }
}

export type Action = SetConnectedStatus | SetDisConnectedCounter;
